module.exports = __webpack_public_path__ + "vue-dist/img/exam-failed.1d2b2263.png";